module.exports = __webpack_public_path__ + "static/media/1.1.21682943.jpg";